import { closeMiniApp } from '@telegram-apps/sdk-react';

import { FallbackUI } from './FallbackUI.tsx';

export function PlatformUnsupported() {
  const handleButtonClick = () => {
    closeMiniApp();
  };

  return (
    <FallbackUI
      buttonTextKey="fallback.close_app"
      messageTextKey="fallback.open_app_on_phone"
      onButtonClick={handleButtonClick}
    />
  );
}
